<template>
	<section class="experience__wrapper">
		<h4 class="experience__role">
			{{ role }}
		</h4>
		<a
			class="experience__company-name"
			:href="companyUrl"
			target="_blank"
			>{{ companyName }}</a
		>
		<div class="experience__secondary-info">
			<span class="year">
				<CalendarIcon />
				<span>{{ year }}</span>
			</span>
			<span class="location">
				<MapPinIcon />
				<span>{{ location }}</span>
			</span>
		</div>
		<div class="experience__company-description">
			{{ companyDescription }}
		</div>
		<ul class="experience__achievements">
			<li v-for="achievement in achievements">
				<span class="experience__achievement-title">
					{{ achievement.title }}
				</span>
				-
				<span>
					{{ achievement.description }}
				</span>
			</li>
		</ul>
	</section>
</template>
<script>
import { MapPinIcon, CalendarIcon } from "vue-feather-icons";

export default {
	components: {
		MapPinIcon,
		CalendarIcon,
	},
	props: [
		"role",
		"companyName",
		"companyUrl",
		"year",
		"location",
		"companyDescription",
		"achievements",
	],
};
</script>
<style lang="scss" scoped>
.experience {
	&__wrapper {
		display: flex;
		flex-direction: column;
		border-bottom: 1px dashed #ccc;
		padding: 15px 0px;
	}
	&__role {
		font-size: 21px;
		line-height: 25px;
		font-weight: 500;
	}
	&__company-name {
		font-size: 15px;
		line-height: 18px;
		font-weight: 700;
		margin: 0px;
		margin-top: 5px;
		color: var(--secondary-theme);
	}
	&__secondary-info {
		font-size: 11px;
		line-height: 1.5;
		-webkit-border-radius: 5px;
		border-radius: 5px;
		margin-top: 5px;
		display: flex;
		align-items: center;
		.year {
			margin-right: 10px;
		}
		> span {
			display: flex;
			align-items: center;
		}
		svg {
			width: 10px;
			height: 10px;
			margin-right: 4px;
		}
	}
	&__company-description {
		font-size: 13px;
		line-height: 16px;
		position: relative;
		margin-top: 5px;
	}
	&__achievements {
		margin: 0px;
		margin-top: 5px;
	}
	&__achievements li span {
		font-size: 13px;
		line-height: 16px;
	}
}
</style>
